import React from "react"
import ReactDOM from "react-dom/client"
// import App from "./App";
import MyApp from './MyApp'
import "./index.css" // Optional styling
import * as ethersModule from 'ethers'
// import { Buffer } from 'buffer';
import process from 'process'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { memerTheme } from './theme/memerTheme'
import { Auth0Provider } from '@auth0/auth0-react'
import { initializeCacheManagement } from './utils/cacheManager'

// Attach to the global window object
window.ethers = ethersModule;
// window.Buffer = Buffer;
window.process = process;

// Initialize cache management before rendering
initializeCacheManagement().then(() => {
    console.log('[Main] Cache management initialized, rendering app...');

    ReactDOM.createRoot(document.getElementById("root")!).render(
        <React.StrictMode>
            <MyApp />
        </React.StrictMode>
    );
}).catch((error) => {
    console.error('[Main] Cache management failed, rendering app anyway:', error);

    // Render app even if cache management fails
    ReactDOM.createRoot(document.getElementById("root")!).render(
        <React.StrictMode>
            <MyApp />
        </React.StrictMode>
    );
});
